"use strict";module.exports=function(r){var e=r.condition,n=r.wrapper,t=r.children;return e?n(t):t};
